import { supabase } from "../supabaseClient";

//*Capture-Image-Url
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

//*Projects-Sustenance
// vjOnly = true hides JD / Landowner projects (isVJ = false). The Projects tab "All Projects" list
// calls this without vjOnly on purpose, so JD projects stay visible there.
async function getProjectsForPagination(search, from, to, drpDownSelectedVal, vjOnly = false) {
  if (search === undefined) {
    search = null;
  }

  const ProjectFilters = {
    "Name Ascending": {
      key: "projectName",
      isAscending: true,
    },
    "Name Descending": {
      key: "projectName",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };
  var query;
  query = supabase
    .from("Projects")
    .select("*", { count: "exact" })
    // .eq("isVJ", true)
    .order(ProjectFilters[drpDownSelectedVal].key, {
      ascending: ProjectFilters[drpDownSelectedVal].isAscending,
    })
    .range(from, to);

  if (search !== null) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("projectName", `%${search}%`);
  }
  if (vjOnly) {
    query = query.eq("isVJ", true);
  }

  const { data, count, error } = await query;
  if (data) return { data, count };
  else throw error;
}
// ! get proejcts that are assigned to loggedInUser
// vjOnly = true hides JD / Landowner projects; the Projects tab "All Projects" list calls this without it.
async function getAssignedProjects(
  search,
  from,
  to,
  drpDownSelectedVal,
  loggedInUserId,
  vjOnly = false
) {
  // console.log(search, from, to, drpDownSelectedVal);

  if (search === undefined) {
    search = null;
  }

  const ProjectFilters = {
    "Name Ascending": {
      key: "projectName",
      isAscending: true,
    },
    "Name Descending": {
      key: "projectName",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };
  var query;
  query = supabase
    .from("SustenanceSalesRelations")
    // inner join so rows of JD projects are removed (callers read row.projectId.* directly)
    .select(vjOnly ? "*, projectId!inner(*)" : "*, projectId(*)", { count: "exact" })
    .eq("userId", loggedInUserId);
  if (vjOnly) {
    query = query.eq("projectId.isVJ", true);
  }
  // .order(ProjectFilters[drpDownSelectedVal].key, { ascending: ProjectFilters[drpDownSelectedVal].isAscending })
  // .range(from, to);
  if (from !== null && to !== null) {
    query = query.range(from, to);
  }
  if (search !== null) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("projectId.projectName", `%${search}%`);
  }

  const { data, count, error } = await query;
  // console.log(data);
  if (data) return { data, count };
  else throw error;
}

//*Sustenance-Inventory-and-Direct-Allotment
async function getProjectsByProjectName(uid, projectName) {
  return await supabase
    .from("Projects")
    .select("*")
    .eq("projectId", uid)
    .eq("projectName", projectName);
}

async function getAllWingsByProjectId(projectId) {
  const { data, error, count } = await supabase
    .from("ProjectInventoryRelations")
    .select("*,wingId(*)", { count: "exact" })
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}
async function getAvailableIdInventoryStatus() {
  const { data, error } = await supabase
    .from("InventoryStatus")
    .select("*")
    .eq("status", "Available")
    .single();
  if (data) return { data };
  else throw error;
}
async function getAllWingsForProjects(projectId) {
  let statusId = await getAvailableIdInventoryStatus();
  const { data, error, count } = await supabase
    .from("ProjectInventoryRelations")
    .select("*,wingId(*),unitId(*,inventoryStatusId(*),inventoryTypeId(*))", {
      count: "exact",
    })
    .eq("projectId", projectId);
  // .eq('unitId.inventoryStatusId.inventoryStatusId', statusId.data.inventoryStatusId);
  if (data) return { data, count };
  else throw error;
}

async function getWingsByProjectId(projectId) {
  const { data, error, count } = await supabase
    .from("Wings")
    .select("*", { count: "exact" })
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}
async function getSelectedWingsByProjectId(projectId) {
  const { data, error, count } = await supabase
    .from("ProjectInventoryRelations")
    .select("*, wingId(*)", { distinct: true })
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}

async function getAllUnitsByWingId(projectId, wingId) {
  const { data, error, count } = await supabase
    .from("ProjectInventoryRelations")
    .select(
      "*  , unitId(* , inventoryStatusId(*) , inventoryMergeId(*) , inventoryTypeId(*) , leadId(* , userId(*))) , wingId(*)",
      { count: "exact" }
    )
    .eq("projectId", projectId)
    .eq("wingId", wingId);
  if (data) return { data, count };
  else throw error;
}

async function getAllUnitsByProjectId(projectId) {
  const { data, error, count } = await supabase
    .from("ProjectInventoryRelations")
    .select(
      "*  , unitId(* , inventoryStatusId(*) , inventoryMergeId(*)) , wingId(*)",
      { count: "exact" }
    )
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}
async function getAllUnitsByProjectIdWings(projectId,wingId) {
  const { data, error, count } = await supabase
    .from("ProjectInventoryRelations")
    .select(
      "*  , unitId(* , inventoryStatusId(*) , inventoryMergeId(*)) , wingId(*)",
      { count: "exact" }
    )
    .eq("projectId", projectId)
    .eq("wingId", wingId);
  if (data) return { data, count };
  else throw error;
}


async function getProjectByProjectName(projectId) {
  const { data, error, count } = await supabase
    .from("Projects")
    .select("*", { count: "exact" })
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}

async function getWingsIdByWingName(wingName) {
  const { data, error, count } = await supabase
    .from("Wings")
    .select("*", { count: "exact" })
    .eq("wingId", wingName);
  if (data) return { data, count };
  else throw error;
}

async function getUnitByUnitNo(UnitNo) {
  const { data, error, count } = await supabase
    .from("Inventory")
    .select(
      "* , projectId(*), inventoryMergeId(*), inventoryTypeId(*) , wingId(*) , inventoryStatusId(*) , leadId(* , personId(*) , AllotmentPayment!left(*  , userId(*)))",
      { count: "exact" }
    )
    .eq("unitId", UnitNo);
  if (data) return { data, count };
  else throw error;
}

async function getAllUnitsStatuses(projectId, wingId) {
  const { data, error, count } = await supabase
    .from("Inventory")
    .select(
      "* , inventoryMergeId(*), inventoryTypeId(*) , wingId(wingName) , inventoryStatusId(*) , leadId(* , personId(*))",
      { count: "exact" }
    )
    .eq("projectId", projectId)
    .eq("wingId", wingId);
  if (data) return { data, count };
  else throw error;
}

async function getInventoryTypeFromProjectName(projectId) {
  const { data, error, count } = await supabase
    .from("Inventory")
    .select(
      "inventoryTypeId(inventoryTypeId , type) , chargeableArea, saleableArea, displayUnitType",
      { count: "exact" }
    )
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}
async function getInventoryTypeFromProjectWing(projectId, wingId) {
  const { data, error, count } = await supabase
    .from("Inventory")
    .select(
      "inventoryTypeId(inventoryTypeId , type), chargeableArea, saleableArea, displayUnitType",
      { count: "exact" }
    )
    .eq("projectId", projectId)
    .eq("wingId", wingId);
  if (data) return { data, count };
  else throw error;
}

async function getLeadDetailsForSustenance(leadId, unitId) {
  const { data, error, count } = await supabase
    .from("UnitInterests")
    .select("*", { count: "exact" })
    .eq("leadId", leadId)
    .eq("unitId", unitId);
  if (data) return { data, count };
  else throw error;
}

async function getAllInventoryStatusFromTable() {
  const { data, error, count } = await supabase
    .from("InventoryStatus")
    .select("*", { count: "exact" });
  if (data) return { data, count };
  else throw error;
}

//*Sustenance-Site-Visit
async function getAllLeadsFromPerson() {
  const { data, error } = await supabase
    .from("Leads")
    .select("* , personId(*) , cpId(billingName)");
  if (data) return { data };
  else throw error;
}

async function getAllCpFromCpContactPerson() {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("* , CP(cpId)");
  if (data) return { data };
  else throw error;
}

async function AddSite(obj) {
  const { data, error } = await supabase.from("SiteVisits").insert(obj);
  if (data) return data;
  else throw error;
}

async function getLeadDetailsByLeadName(LeadName) {
  const { data, error } = await supabase
    .from("Person")
    .select("*")
    .eq("name", LeadName);
  if (data) return { data };
  else throw error;
}

async function getLeadIdFromLeadTable(personId) {
  const { data, error } = await supabase
    .from("Leads")
    .select("*")
    .eq("personId", personId);
  if (data) return { data };
  else throw error;
}

async function getCpDetailsByCpId(CpId) {
  const { data, error } = await supabase
    .from("CpContactPerson")
    .select("* , CP(cpType)")
    .eq("cpId", CpId);
  if (data) return { data };
  else throw error;
}

async function getFosDetailsByFosId(fosId) {
  const { data, error } = await supabase
    .from("FOS")
    .select("*")
    .eq("fosId", fosId);
  if (data) return { data };
  else throw error;
}

async function getKycIdFromKycDoc(docNumber) {
  const { data, error } = await supabase
    .from("KycDocuments")
    .select("*")
    .eq("docNumber", docNumber)
    .is("leadId", null);
  if (data) return { data };
  else throw error;
}

async function getUsersInSus(search) {
  const { data, error } = await supabase.from("Users").select("userId , name");
  if (data) return { data };
  else throw error;
}

async function getUserByUserName(UserName) {
  const { data, error } = await supabase
    .from("Users")
    .select("* ")
    .eq("name", UserName);
  if (data) return { data };
  else throw error;
}

async function CaptureImageInSiteVisit(obj, id) {
  const file = dataURLtoFile(obj, `${id}.webp`);
   // console.log({ obj, file });

  return supabase.storage
    .from("sitevisit")
    .upload(`${id}.webp`, file)
    .then((res) => {
      if (res.data) {
        // console.log("Data uploaded to storage", res);
        supabase
          .from("SiteVisits")
          .update({ photoUrl: res.data.Key })
          .eq("siteVistId", id)
          .then((SiteVisit) => {
            if (SiteVisit.data) {
              // console.log("images saved in SiteVisit");
            } else {
              // console.log("Didn't save", SiteVisit.error);
            }
          });
      } else {
        // console.log("Something went wrong", res.error);
      }
    });
}

async function getAllSiteVisits(
  projectId,
  from,
  to,
  search,
  drpDownSelectedVal,
  selectedCp,
  selectedSales,
  selectDates,
  selectedDates
) {
  // console.log("projectId", projectId);
  // console.log("from", from);
  // console.log("to", to);
  // console.log("search", search);
  // console.log("drpDownSelectedVal", drpDownSelectedVal);

  if (search === undefined) {
    search = null;
  }

  const SiteVisitFilters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "sitevisitdate",
      isAscending: true,
    },
    "Latest First": {
      key: "sitevisitdate",
      isAscending: false,
    },
  };
  var query;
  query = supabase
    .rpc(
      "sitevisitsofleadsforsustenance",
      { pid: projectId },
      { count: "exact" }
    )
    .order(SiteVisitFilters[drpDownSelectedVal].key, {
      ascending: SiteVisitFilters[drpDownSelectedVal].isAscending,
    })
    .range(from, to)
    .in("userid", JSON.parse(localStorage.getItem("teamIds")));

  if (search !== null || search !== "" || search !== undefined) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("leadname", `%${search}%`);
  }

  if (selectedCp.length !== 0) {
    // console.log(selectedCp);
    query = query.in("cpid", selectedCp);
  }

  if (selectedSales.length !== 0) {
    // console.log(selectedSales);
    query = query.in("userid", selectedSales);
  }

  if (selectedDates !== null) {
    // console.log(selectedDates);
    query = query
      .gte("sitevisitdate", new Date(selectDates[0].value).getTime())
      .lte("sitevisitdate", new Date(selectDates[1].value).getTime());
  }

  const { data, count, error } = await query;
  // console.log(data);
  if (data) return { data, count };
  else throw error;
}

//*Sustenance-Cp-and-Sales
async function getAllCpForPagination(from, to, projectId) {
  const { data, error, count } = await supabase
    .from("SustenanceCpRelations")
    .select("* , cpId(* , CpContactPerson(*)) )", { count: "exact" })
    .eq("projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}
async function getAllCpForSustenance() {
  const { data, error, count } = await supabase
    .from("CP")
    .select("cpId,billingName , CpContactPerson(name,email,contactNumber)", { count: "exact" })
    .eq("approvalStatus", "approved");
  if (data) return { data, count };
  else throw error;
}
async function SaveSelectedCp(obj) {
  const { data, error, count } = await supabase
    .from("SustenanceCpRelations")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function DeleteSelectedCps(obj, projectId) {
  let query = supabase
    .from("SustenanceCpRelations")
    .delete()
    .eq("projectId", projectId)
    .eq("cpId", obj.cpId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function CpRelationsData(projectId, cpId) {
  const { data, error, count } = await supabase
    .from("SustenanceCpRelations")
    .select("*", { count: "exact" })
    .eq("projectId", projectId)
    .eq("cpId", cpId);

  if (data) return { data, count };
  else throw error;
}

async function getAllCpByProject(projectId) {
  const { data, error, count } = await supabase
    .from("SustenanceCpRelations")
    .select("cpId", { count: "exact" })
    .eq("projectId", projectId);

  if (data) return { data, count };
  else throw error;
}

async function SalesRelationsData(projectId, userId) {
  const { data, error, count } = await supabase
    .from("SustenanceSalesRelations")
    .select("*", { count: "exact" })
    .eq("projectId", projectId)
    .eq("userId", userId);

  if (data) return { data, count };
  else throw error;
}

async function PricingRelationsData(projectId, pricingId) {
  const { data, error, count } = await supabase
    .from("SustenancePricingRelations")
    .select("*", { count: "exact" })
    .eq("projectId", projectId)
    .eq("projectPricingId", pricingId);

  if (data) return { data, count };
  else throw error;
}

async function PaymentRelationsData(projectId) {
  const { data, error, count } = await supabase
    .from("SustenancePaymentPlanRelations ")
    .select("*", { count: "exact" })
    .eq("projectId", projectId);

  if (data) return { data, count };
  else throw error;
}

async function getAllUsersForSustenance(from, to, projectId) {
  const { data, error, count } = await supabase
    .from("SustenanceSalesRelations")
    .select("* , userId(*)", { count: "exact" })
    .eq("projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getAllPricingForSustenance(from, to, projectId) {
  const { data, error, count } = await supabase
    .from("SustenancePricingRelations ")
    .select("*  , projectPricingId(* , wingId(*))", { count: "exact" })
    .eq("projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getAllPaymentsForSustenance(from, to, projectId) {
  const { data, error, count } = await supabase
    .from("SustenancePaymentPlanRelations  ")
    .select("* , paymentPlanId(* , wingId(*) , inventoryTypeId(*))", {
      count: "exact",
    })
    .eq("projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getAllUsers(from, to) {
  const { data, error, count } = await supabase
    .from("Users")
    .select("*", { count: "exact" })
    .eq("isActive", true)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getAllProjectPrice(projectId) {
  const { data, error, count } = await supabase
    .from("SustenancePricingRelations")
    .select("*", { count: "exact" })
    .eq("projectId", projectId);
  if (data) return { data, count };
  else throw error;
}

async function getAllPaymentPlans(from, to, projectId) {
  const { data, error, count } = await supabase
    .from("PaymentPlans")
    .select("* , wingId(*) , inventoryTypeId(*)", { count: "exact" })
    .eq("projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function SaveSelectedUsers(obj) {
  const { data, error, count } = await supabase
    .from("SustenanceSalesRelations")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function DeleteSelectedSales(obj, projectId) {
  let query = supabase
    .from("SustenanceSalesRelations")
    .delete()
    .eq("projectId", projectId)
    .eq("userId", obj.userId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function SaveSelectedUsersForWings(obj) {
  const { data, error, count } = await supabase
    .from("SustenanceWingsSalesRelations")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function DeleteSelectedSalesForWings(projectId,obj,wingId) {
  let query = supabase
    .from("SustenanceWingsSalesRelations")
    .delete()
    .eq("projectId",projectId)
    .eq("userId", obj.userId)
    .eq("wingId", wingId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function SaveSelectedUsersForFloors(obj) {
  const { data, error, count } = await supabase
    .from("SustenanceFloorsSalesRelations")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function DeleteSelectedSalesForFloors(projectId,obj,floorWingId,projectFloorNo) {
  let query = supabase
    .from("SustenanceFloorsSalesRelations")
    .delete()
    .eq("projectId", projectId)
    .eq("userId", obj.userId)
    .eq("wingId", floorWingId)
    .eq("floorNo",projectFloorNo);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}


async function getAllSalesByProjectWingsUser(projectId,userId) {
  let query = supabase.from('SustenanceWingsSalesRelations').select('*').eq('projectId', projectId).eq('userId', userId)
  const { data, error ,count} = await query;
  if (data) return { data,count };
  else throw error;
}
async function getAllSalesByProjectFloorsUser(projectId,userId) {
  let query = supabase.from('SustenanceFloorsSalesRelations').select('*').eq('projectId', projectId)
  .eq('userId', userId)
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function getAllSalesByProjectFloors(projectId,userId,wingId) {
  let query = supabase.from('SustenanceFloorsSalesRelations').select('*').eq('projectId', projectId)
  .eq('userId', userId)
  .eq('wingId', wingId)
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}
async function SaveSelectedPrices(obj) {
  const { data, error, count } = await supabase
    .from("SustenancePricingRelations")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function DeleteSelectedPrices(obj, projectId) {
  let query = supabase
    .from("SustenancePricingRelations")
    .delete()
    .eq("projectId", projectId)
    .eq("projectPricingId", obj.projectPricingId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

async function SaveSelectedPaymentPlans(obj) {
  const { data, error, count } = await supabase
    .from("SustenancePaymentPlanRelations ")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function DeleteSelectedPlans(obj, projectId) {
  let query = supabase
    .from("SustenancePaymentPlanRelations")
    .delete()
    .eq("projectId", projectId)
    .eq("paymentPlanId", obj.paymentPlanId);
  const { data, error } = await query;
  if (data) return { data };
  else throw error;
}

//*Sustenance-Leads
async function getAllLeadsForSustenanceFromRpc(
  projectId,
  from,
  to,
  search,
  drpDownSelectedVal,
  selectDates,
  selectedDates,
  selectedCP,
  selectedSales,
  selectedProjects,
  selectedLeadQuality,
  selectedStatus,
  loggedInUserId
) {
  const TabFilters = {
    "Name Ascending": {
      key: "leadname",
      isAscending: true,
    },
    "Name Descending": {
      key: "leadname",
      isAscending: false,
    },
    "Oldest First": {
      key: "last_updated_at",
      isAscending: true,
    },
    "Latest First": {
      key: "last_updated_at",
      isAscending: false,
    },
  };

  var query;
  query = supabase
    .rpc("leadsfilter", {}, { count: "exact" })
    .order(TabFilters[drpDownSelectedVal].key, {
      ascending: TabFilters[drpDownSelectedVal].isAscending,
    })
    .range(from, to);

  if (search !== null || search !== "" || search !== undefined) {
    search = search.replace(/\s\s+/g, " ");
    query = query.ilike("leadname", `%${search}%`);
  }
  if (selectedSales.length !== 0) {
    // console.log(selectedSales);
    query = query.in("salesid", selectedSales);
  }
  if (selectedProjects.length !== 0) {
    // console.log(selectedProjects);
    query = query.in("projectname", selectedProjects);
  }
  if (selectedStatus.length !== 0) {
    // console.log(selectedSales);
    query = query.in("leadstatus", selectedStatus);
  }
  if (selectedLeadQuality.length !== 0) {
    query = query.in("leadresponse", selectedLeadQuality);
  }
  if (selectedCP.length !== 0) {
    query = query.in("cpid", selectedCP);
  }
  if (selectedDates !== null) {
    // console.log(selectedDates);
    query = query
      .gte("created_at", new Date(selectDates[0].value).getTime())
      .lte("created_at", new Date(selectDates[1].value).getTime());
  }
  const { data, count, error } = await query.eq("projectid", projectId);
  if (data) return { data, count };
  else throw error;
}

//*Sustenance-Direct-Allotment-Payment-Gateway
async function getAllLeadsForSearch() {
  let query = supabase
    .from("Leads")
    .select("* ,LeadLogs!left(*) , personId(*)", { count: "exact" })
    .in("userId", JSON.parse(localStorage.getItem("teamIds")))
    .order("created_at", { ascending: false });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getAllLeadsForSustenance() {
  let query = supabase
    .from("Leads")
    .select("* ,LeadLogs!left(*) , personId(*),SiteVisits!left(*)", {
      count: "exact",
    })
    .in("userId", JSON.parse(localStorage.getItem("teamIds")))
    .order("created_at", { ascending: false });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getLeadLogs(leadId) {
  let query = supabase
    .from("LeadLogs")
    .select("*", { count: "exact" })
    .eq("leadId", leadId)
    .order("created_at", { ascending: false });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getLeadInfo(leadId) {
  let query = supabase
    .from("Leads")
    .select("* ,LeadLogs!left(*), personId(*)", { count: "exact" })
    .eq("leadDisplayId", leadId)
    .order("created_at", { ascending: false });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function RemoveLeadFromInterestQueue(UnitInterestId) {
  let query = supabase
    .from("UnitInterests")
    .delete()
    .eq("unitInterestId", UnitInterestId);
  const { data, error } = await query;
  if (data) return data;
  else throw error;
}

async function AddPaymentData(obj) {
  const { data, count, error } = await supabase
    .from("AllotmentPayment")
    .insert(obj);
  if (data) return { data, count };
  else throw error;
}

async function getLeadDetailsFromInventory(unitNo) {
  const { data, count, error } = await supabase
    .from("Inventory")
    .select("*", { count: "exact" })
    .eq("unitId", unitNo);
  if (data) return { data, count };
  else throw error;
}

async function UpdateLeadIdToInventory(obj, unitNo) {
  const { data, count, error } = await supabase
    .from("Inventory")
    .update(obj)
    .eq("unitId", unitNo);
  if (data) return { data, count };
  else throw error;
}

//*Sustenance-Cancel-Units-Requests
async function getCancelUnitRequests(projectId, from, to) {
  const { data, count, error } = await supabase
    .from("CancelUnitRequests")
    .select(
      "* , userId(*) ,allotmentPaymentId(* ,unitId(* ,wingId(*), projectId(*) ,inventoryTypeId(*)), leadId(* , personId(*) , cpId(*)))",
      { count: "exact" }
    )
    .eq("allotmentPaymentId.unitId.projectId.projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

//*Sustenance-Change-Unit-Requests
async function getChangeUnitRequests(projectId, from, to) {
  const { data, count, error } = await supabase
    .from("ChangeUnitRequests")
    .select(
      "* , userId(*) ,allotmentPaymentId(* ,unitId(* ,wingId(*), projectId(*) ,inventoryTypeId(*)), leadId(* , personId(*) , cpId(*)))",
      { count: "exact" }
    )
    .eq("allotmentPaymentId.unitId.projectId.projectId", projectId)
    .range(from, to);
  if (data) return { data, count };
  else throw error;
}

async function getAllProjects() {
  const { data, error } = await supabase.from("Projects").select("buId").eq("isVJ", true);
  if (data) return { data };
  else throw error;
}

//*Sustenance-Collaterals
async function getProjectCollaterals(userId, projectId, selectedFolderId) {
  // console.log("selectedFolderId", selectedFolderId);
  let query = supabase
    .from("ProjectCollateralSalesRelations")
    .select("*,ProjectCollaterals!inner(*)", { count: "exact" })
    .eq("userId", userId)
    .lte("startDateTime", Date.now())
    .gte("endDateTime", Date.now())
    .eq("ProjectCollaterals.projectId", projectId);

  if (selectedFolderId !== null && selectedFolderId !== undefined) {
    query = query.eq("ProjectCollaterals.parentId", selectedFolderId);
  }

  // if (selectedFolderId === null) {
  //     query = query.is("ProjectCollaterals.parentId", null);
  //   }

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getProjectCollateralId(parentId, fileName) {
  let query = supabase
    .from("ProjectCollaterals")
    .select("*", { count: "exact" })
    .eq("projectId", parentId)
    .eq("fileName", fileName);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getUnitCancellation(unitId) {
  const { data, error, count } = await supabase
    .from("AllotmentPayment")
    .select("*,CancelUnitRequests!left(status,unitPriceAlreadyUpdated)", {
      count: "exact",
    })
    .eq("unitId", unitId)
    //.eq('status', 'Cancelled')
    .in("status", ["Cancelled", "Refund Processed", "Refund Initiated"])
    .order("created_at", { ascending: false })
    .limit(1);
  if (data) return { data, count };
  else throw error;
}
export {
  //*Project-details
  getProjectsByProjectName,
  getProjectByProjectName,
  getProjectsForPagination,
  //*View-wings-units
  getAllWingsByProjectId,
  getAllUnitsByWingId,
  getAllUnitsByProjectId,
  getAllUnitsByProjectIdWings,
  getWingsIdByWingName,
  getAllProjects,

  //*Cp-sales
  getAllCpForPagination,
  getAllCpForSustenance,
  SaveSelectedCp,
  SaveSelectedUsers,
  CpRelationsData,
  SalesRelationsData,
  DeleteSelectedSales,
  DeleteSelectedCps,
  getAllCpByProject,

  //*Leads
  getAllLeadsForSustenanceFromRpc,

  //*Site-Visit
  getAllLeadsFromPerson,
  getAllCpFromCpContactPerson,
  AddSite,
  getLeadDetailsByLeadName,
  getCpDetailsByCpId,
  getKycIdFromKycDoc,
  getUsersInSus,
  getAllUsers,
  getInventoryTypeFromProjectName,
  getFosDetailsByFosId,
  getProjectCollateralId,
  getUserByUserName,
  CaptureImageInSiteVisit,
  getLeadIdFromLeadTable,
  getAllSiteVisits,
  getAllUsersForSustenance,

  //*DA
  getUnitByUnitNo,
  AddPaymentData,
  getAllLeadsForSearch,
  getLeadDetailsForSustenance,
  getLeadDetailsFromInventory,
  UpdateLeadIdToInventory,
  RemoveLeadFromInterestQueue,
  getAllInventoryStatusFromTable,
  getLeadInfo,
  getAllUnitsStatuses,
  getWingsByProjectId,
  getLeadLogs,

  //*Price-List
  getAllPricingForSustenance,
  getAllProjectPrice,
  PricingRelationsData,
  SaveSelectedPrices,
  DeleteSelectedPrices,
  SaveSelectedUsersForWings,
  DeleteSelectedSalesForWings,
  SaveSelectedUsersForFloors,
  DeleteSelectedSalesForFloors,
  getAllSalesByProjectWingsUser,
  getAllSalesByProjectFloorsUser,
  getAllSalesByProjectFloors,
  //*paymentsPlans
  getAllPaymentsForSustenance,
  getAllPaymentPlans,
  PaymentRelationsData,
  SaveSelectedPaymentPlans,
  DeleteSelectedPlans,

  //*change-Unit
  getChangeUnitRequests,

  //*cancel-Unit
  getCancelUnitRequests,
  // ! vedashree changes
  getInventoryTypeFromProjectWing,
  getSelectedWingsByProjectId,
  getAllWingsForProjects,
  getAssignedProjects,
  getAllLeadsForSustenance,

  //*Collaterals
  getProjectCollaterals,
  getUnitCancellation,
};
